(() => {
  if (window.shoptimizerInsightsTracking) return;
  const storageKey = 'shoptimizer.insights.views.v1';
  const seen = new Set();
  const storefrontOrigins = new Set([
    'https://shoptimizer.at', 'https://www.shoptimizer.at',
    'https://optimizzer.at', 'https://www.optimizzer.at'
  ]);
  const renderedPageHandle = document.currentScript?.dataset.insightsPageHandle;
  const transportConnections = Object.freeze({
    test: Object.freeze({enabled: false, projectId: 'shoptimizer-develop',
      apiBase: 'https://europe-west1-shoptimizer-develop.cloudfunctions.net/insightsApi', measurementId: 'G-KF1KMG4GGN', meta: true}),
    production: Object.freeze({enabled: true, projectId: 'dauntles-shoptimizer',
      apiBase: 'https://europe-west1-dauntles-shoptimizer.cloudfunctions.net/insightsApi', measurementId: 'G-TJ3RZ8B19W', meta: false, browserMeta: true})
  });
  const pageGroups = Object.freeze({'/': 'home', '/pages/insights-single': 'single',
    '/pages/insights-competitors': 'competitors', '/pages/insights-report': 'report',
    '/pages/insights-benchmark': 'benchmark', '/pages/insights-top-standorte': 'top-standorte',
    '/pages/insights-recent': 'recent', '/pages/plane': 'pricing'});
  // Browser Meta supports these published pages without extending the backend's page_group contract.
  const storefrontPages = new Set([...Object.keys(pageGroups), ...[
    'insights-search', 'focus', 'facus', 'tools', 'tools-answer', 'tools-branches', 'tools-check',
    'tools-decisions', 'tools-focus', 'tools-gallery', 'tools-goal', 'tools-labs',
    'tools-planner', 'tools-poster', 'tools-qr', 'tools-quiz', 'tools-scenario',
    'tools-survey', 'tools-trial', 'optimizzer-karriere', 'optimizzer-ueber-uns',
    'sales-manager-b2b', 'ueber-uns'
  ].map(handle => '/pages/' + handle)]);
  function normalizedPath(path) {
    return path.replace(/^\/(?:de|en|fr|it|nl|es)(?:-[a-z]{2})?(?=\/|$)/i, '').replace(/\/$/, '') || '/';
  }
  function pageFor(url) {
    let path = normalizedPath(url.pathname);
    if (path === '/pages' && url.origin === window.location.origin && typeof renderedPageHandle === 'string') {
      path = '/pages/' + renderedPageHandle;
    }
    if (path === '/pages/contact-us') {
      const view = url.searchParams.get('view');
      if (view && storefrontPages.has('/pages/' + view)) path = '/pages/' + view;
    }
    return path;
  }
  function preview() {
    const url = new URL(window.location.href);
    const role = window.Shopify?.theme?.role;
    return window.Shopify?.designMode === true || (role && role !== 'main') ||
      url.searchParams.has('preview_theme_id') || url.searchParams.has('preview_key') ||
      (normalizedPath(url.pathname) === '/pages/contact-us' && url.searchParams.has('view'));
  }

  const managerEntries = ['https://analytics.shoptimizer.at/login',
    'https://shoptimizer-manager-develop.web.app/login', document.currentScript?.dataset.insightsManagerUrl]
    .flatMap(value => {
      try {
        const url = new URL(value);
        return ['http:', 'https:'].includes(url.protocol) ? [url] : [];
      } catch (_) { return []; }
    });
  const names = {
    search_started: {ga4: 'search_started', meta: 'InsightsSearch'},
    report_viewed: {ga4: 'report_viewed', meta: 'InsightsReportViewed'},
    cta_clicked: {ga4: 'insights_cta', meta: 'InsightsCTA'}
  };

  function permissions() {
    try {
      const consent = window.shoptimizerConsent;
      return {
        ga4: consent?.allowed(['analytics']) === true,
        meta: consent?.allowed(['analytics', 'marketing', 'sale_of_data']) === true
      };
    } catch (_) {
      return {ga4: false, meta: false};
    }
  }

  function propertiesFor(name, properties) {
    const keys = Object.keys(properties);
    if (name === 'search_started' && !keys.length) return {};
    if (name === 'report_viewed' && keys.length === 1 && keys[0] === 'report_type' &&
        ['single', 'competitors', 'benchmark'].includes(properties.report_type)) {
      return {report_type: properties.report_type};
    }
    if (name === 'cta_clicked' && keys.length === 1 && keys[0] === 'target' &&
        ['compare', 'register', 'contact'].includes(properties.target)) {
      return {target: properties.target};
    }
    return null;
  }

  function sendBrowserMeta(packet, valid) {
    // Only this projection waits for the existing SDK; never queue into an fbq stub.
    const deadline = Date.now() + 5000;
    let timer;
    let active = true;
    function stop() {
      active = false;
      clearTimeout(timer);
      document.removeEventListener('visitorConsentCollected', changed);
      document.removeEventListener('shopify:section:unload', stop);
      window.removeEventListener('pagehide', stop);
    }
    function changed() { if (!permissions().meta) stop(); }
    function attempt() {
      if (!active) return;
      try {
        if (Date.now() >= deadline || !valid() || !permissions().meta) { stop(); return; }
        const pixel = window.fbq;
        if (typeof pixel === 'function' && typeof pixel.callMethod === 'function' && typeof pixel.getState === 'function') {
          const pixels = pixel.getState()?.pixels;
          if (Array.isArray(pixels) && pixels.some(item => String(item.id) === '156158179819706')) {
            // getState can invoke other code: recheck immediately before dispatch.
            if (!active || Date.now() >= deadline || !valid() || !permissions().meta) { stop(); return; }
            stop();
            pixel('trackSingleCustom', '156158179819706', packet.meta.name,
              {source: packet.envelope.source, ...packet.envelope.properties}, {eventID: packet.envelope.event_id});
            return;
          }
        }
        timer = setTimeout(attempt, 50);
      } catch (_) { stop(); }
    }
    document.addEventListener('visitorConsentCollected', changed);
    document.addEventListener('shopify:section:unload', stop);
    window.addEventListener('pagehide', stop);
    attempt();
  }

  let pricingPrepared;
  let pricingPreparation;
  let pricingEpoch = 0;
  function navigationPage() {
    return storefrontOrigins.has(window.location.origin) &&
      storefrontPages.has(pageFor(new URL(window.location.href))) && !preview();
  }
  function pricingSignature(root) {
    return JSON.stringify(['backendConnection', 'designMode', 'api', 'apiBase', 'firebaseApiKey', 'appCheckApiKey',
      'firebaseProjectId', 'appCheckProjectId', 'firebaseAppId', 'appCheckAppId', 'appCheckSiteKey']
      .map(key => root.dataset[key]));
  }
  function preparedPricing(root, sdk, dataLayer) {
    return pricingPrepared?.root === root && pricingPrepared.sdk === sdk && pricingPrepared.dataLayer === dataLayer &&
      pricingPrepared.signature === pricingSignature(root) && Date.now() - pricingPrepared.at < 300000
      ? pricingPrepared.result : null;
  }
  function preparePricing() {
    try {
      if (!permissions().ga4 || !navigationPage()) return;
      const root = document.querySelectorAll('[data-backend-connection]')[0];
      const config = transportConnections.production;
      const sdk = window.gtag;
      const dataLayer = window.dataLayer;
      if (!root?.isConnected || root.dataset.backendConnection !== 'production' || root.dataset.designMode === 'true' ||
          (root.dataset.firebaseProjectId || root.dataset.appCheckProjectId) !== config.projectId ||
          (root.dataset.apiBase || root.dataset.api)?.replace(/\/+$/, '') !== config.apiBase ||
          typeof sdk !== 'function' || !Array.isArray(dataLayer) || pricingPreparation || preparedPricing(root, sdk, dataLayer)) return;
      const epoch = pricingEpoch;
      const signature = pricingSignature(root);
      const valid = () => epoch === pricingEpoch && root.isConnected && permissions().ga4 &&
        pricingSignature(root) === signature && window.gtag === sdk && window.dataLayer === dataLayer;
      let timer;
      function readSdk(command, measurementId, field, callback) { dataLayer.push(arguments); }
      const ids = Promise.race([
        Promise.all(['client_id', 'session_id'].map(field => new Promise(resolve => readSdk('get', config.measurementId, field, resolve)))),
        new Promise(resolve => { timer = setTimeout(() => resolve(null), 250); })
      ]).finally(() => clearTimeout(timer));
      const headers = (async () => {
        if (!window.ShoptimizerAppCheck) {
          const helperUrl = new URL(root.dataset.appCheckHelperUrl, window.location.origin);
          if (helperUrl.protocol !== 'https:' || helperUrl.username || helperUrl.password || helperUrl.hash ||
              (helperUrl.origin !== window.location.origin && helperUrl.hostname !== 'cdn.shopify.com') ||
              !helperUrl.pathname.endsWith('/shoptimizer-app-check.min.js')) return null;
          await import(helperUrl.href);
        }
        if (!valid()) return null;
        return window.ShoptimizerAppCheck?.getHeadersFromElement(root);
      })();
      pricingPreparation = Promise.all([ids, headers]).then(result => {
        if (valid() && result[0]?.every(value => value != null) && typeof result[1]?.['X-Firebase-AppCheck'] === 'string') {
          pricingPrepared = {root, sdk, dataLayer, signature, at: Date.now(), result};
        }
      }).catch(() => {}).finally(() => { pricingPreparation = null; });
    } catch (_) {}
  }
  if (navigationPage()) {
    window.shoptimizerConsent?.register('insights-pricing', ['analytics'], preparePricing);
    document.addEventListener('DOMContentLoaded', preparePricing);
    document.addEventListener('visitorConsentCollected', () => {
      pricingEpoch++;
      pricingPrepared = null;
      preparePricing();
    });
    for (const event of ['pointerover', 'focusin']) document.addEventListener(event, e => {
      if (e.target.closest?.('[data-insights-cta], a.st-editor-cta, a.focus-content__button, .optimizzer-career a, .optimizzer-about a')) preparePricing();
    });
    window.addEventListener('pagehide', () => { pricingEpoch++; pricingPrepared = null; });
  }

  async function send(packet) {
    if (!packet.ga4 && !packet.meta) return;
    let cleanup = () => {};
    try {
      const root = Array.from(document.querySelectorAll('[data-backend-connection]'))
        .find(element => Object.hasOwn(transportConnections, element.dataset.backendConnection));
      if (!root?.isConnected || root.dataset.designMode === 'true') return;
      const config = transportConnections[root.dataset.backendConnection];
      if (!config?.enabled || !config.apiBase || (root.dataset.firebaseProjectId || root.dataset.appCheckProjectId) !== config.projectId) return;
      if (config.browserMeta && preview()) return;
      const api = new URL(root.dataset.apiBase || root.dataset.api);
      if (api.href.replace(/\/+$/, '') !== config.apiBase ||
          api.username || api.password || api.search || api.hash) return;
      const connectionApi = api.href;
      function connectionUnchanged() {
        return root.isConnected && root.dataset.designMode !== 'true' &&
          transportConnections[root.dataset.backendConnection] === config &&
          (root.dataset.firebaseProjectId || root.dataset.appCheckProjectId) === config.projectId &&
          new URL(root.dataset.apiBase || root.dataset.api).href === connectionApi;
      }
      const sdk = window.gtag;
      const dataLayer = window.dataLayer;
      const pathname = window.location.pathname;
      const pageContext = pageFor(new URL(window.location.href));
      if (config.browserMeta && packet.meta && storefrontOrigins.has(window.location.origin) &&
          storefrontPages.has(pageContext)) {
        const pageUrl = window.location.href;
        const signature = pricingSignature(root);
        sendBrowserMeta(packet, () => connectionUnchanged() && pricingSignature(root) === signature &&
          window.location.href === pageUrl && !preview() &&
          Array.from(document.querySelectorAll('[data-backend-connection]'))
            .find(element => Object.hasOwn(transportConnections, element.dataset.backendConnection)) === root);
        window.shoptimizerCustomerEvents?.publish(
          'shoptimizer_insights_' + packet.envelope.event_name, packet.envelope.properties, packet.envelope.event_id
        );
      }
      const metaContext = config.meta && packet.meta && Object.hasOwn(pageGroups, pageContext)
        ? Object.freeze({page_group: pageGroups[pageContext]}) : null;
      const canReadSdk = Boolean(packet.ga4) && typeof sdk === 'function' && Array.isArray(dataLayer);
      const appCheck = window.ShoptimizerAppCheck;
      if ((!canReadSdk && !metaContext) ||
          (appCheck ? typeof appCheck.getHeadersFromElement !== 'function' : !root.dataset.appCheckHelperUrl)) return;
      let helperUrl;
      if (!appCheck) {
        helperUrl = new URL(root.dataset.appCheckHelperUrl, window.location.origin);
        if (helperUrl.protocol !== 'https:' || helperUrl.username || helperUrl.password || helperUrl.hash ||
            (helperUrl.origin !== window.location.origin && helperUrl.hostname !== 'cdn.shopify.com') ||
            !helperUrl.pathname.endsWith('/shoptimizer-app-check.min.js')) return;
      }
      const controller = new AbortController();
      const consent = {analytics: Boolean(packet.ga4), marketing: Boolean(packet.meta), sale_of_data: Boolean(packet.meta)};
      let active = true;
      let dispatched = false;
      let sdkTimer;
      let cancelAttempt;
      const cancelled = new Promise(resolve => { cancelAttempt = () => resolve(null); });
      function cancel() {
        if (!active) return;
        active = false;
        controller.abort();
        cancelAttempt();
      }
      function pageHidden() {
        const navigationCTA = packet.envelope.event_name === 'cta_clicked' && storefrontPages.has(pageContext);
        if (!dispatched || (pageContext !== '/pages/plane' && !navigationCTA)) cancel();
      }
      function narrow() {
        try {
          for (const purpose of Object.keys(consent)) {
            consent[purpose] = consent[purpose] && window.shoptimizerConsent?.allowed([purpose]) === true;
          }
        } catch (_) {
          consent.analytics = consent.marketing = consent.sale_of_data = false;
        }
        if (!consent.analytics) cancel();
      }
      const timer = setTimeout(cancel, 5000);
      cleanup = () => {
        active = false;
        clearTimeout(timer);
        clearTimeout(sdkTimer);
        document.removeEventListener('visitorConsentCollected', narrow);
        document.removeEventListener('shopify:section:unload', cancel);
        window.removeEventListener('pagehide', pageHidden);
      };
      document.addEventListener('visitorConsentCollected', narrow);
      document.addEventListener('shopify:section:unload', cancel);
      window.addEventListener('pagehide', pageHidden);
      narrow();
      if (!active) return;
      let prepared = navigationPage() ? preparedPricing(root, sdk, dataLayer) : null;
      if (!prepared && navigationPage() && pricingPreparation) {
        await Promise.race([pricingPreparation, cancelled]);
        if (!active) return;
        prepared = preparedPricing(root, sdk, dataLayer);
      }
      function readSdk(command, measurementId, field, callback) { dataLayer.push(arguments); }
      const ids = !prepared && canReadSdk ? Promise.race([
        Promise.all(['client_id', 'session_id'].map(field => new Promise(resolve => {
          if (!active) { resolve(null); return; }
          readSdk('get', config.measurementId, field, resolve);
        }))),
        new Promise(resolve => { sdkTimer = setTimeout(() => resolve(null), 250); })
      ]).catch(() => null).finally(() => clearTimeout(sdkTimer)) : Promise.resolve(null);
      async function requestHeaders() {
        if (!active) return null;
        if (!window.ShoptimizerAppCheck) await import(helperUrl.href);
        narrow();
        if (!active || !connectionUnchanged()) return null;
        return window.ShoptimizerAppCheck.getHeadersFromElement(root);
      }
      const result = prepared || await Promise.race([
        Promise.all([ids, requestHeaders()]), cancelled
      ]);
      if (!result || !active) return;
      const [sdkIds, headers] = result;
      const [clientId, sdkSessionId] = sdkIds || [];
      const sessionId = typeof sdkSessionId === 'number' && Number.isSafeInteger(sdkSessionId) ? String(sdkSessionId) : sdkSessionId;
      const now = Math.floor(Date.now() / 1000);
      if (packet.envelope.occurred_at < now - 120 || packet.envelope.occurred_at > now + 5 ||
          typeof headers?.['X-Firebase-AppCheck'] !== 'string' || !headers['X-Firebase-AppCheck'].trim()) return;
      narrow();
      if (!active || !connectionUnchanged() || (config.browserMeta && preview())) return;
      const ga4 = consent.analytics && typeof clientId === 'string' && /^[1-9][0-9]{0,19}\.[1-9][0-9]{0,19}$/.test(clientId) &&
        typeof sessionId === 'string' && /^[1-9][0-9]{0,19}$/.test(sessionId) &&
        Number(sessionId) >= now - 86400 && Number(sessionId) <= now + 60
        ? {sdk_measurement_id: config.measurementId, client_id: clientId, session_id: sessionId} : null;
      const meta = consent.analytics && consent.marketing && consent.sale_of_data && window.location.pathname === pathname ? metaContext : null;
      if (!ga4 && !meta) return;
      const body = JSON.stringify({event: packet.envelope, consent, ga4, meta});
      if (new TextEncoder().encode(body).byteLength > 4096) return;
      api.pathname = api.pathname.replace(/\/+$/, '') + '/api/tracking/events';
      dispatched = true;
      await Promise.race([fetch(api.href, {
        method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer', keepalive: true,
        headers: {'Content-Type': 'application/json', 'X-Firebase-AppCheck': headers['X-Firebase-AppCheck']},
        body, signal: controller.signal
      }), cancelled]);
    } catch (_) {} finally { cleanup(); }
  }

  function track(name, properties = {}, localDedupeKey, eligible = permissions()) {
    try {
      if (!Object.hasOwn(names, name)) return null;
      const safeProperties = propertiesFor(name, properties);
      if (!safeProperties) return null;
      const current = permissions();
      const allowed = {ga4: eligible.ga4 && current.ga4, meta: eligible.meta && current.meta};
      if (!allowed.ga4 && !allowed.meta) return null;
      if (localDedupeKey != null && typeof localDedupeKey !== 'string') return null;
      let stored = [];
      const key = localDedupeKey ? name + ':' + localDedupeKey : '';
      if (key) {
        if (seen.has(key)) return null;
        stored = JSON.parse(window.sessionStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(stored) || stored.some(value => typeof value !== 'string') || stored.includes(key)) return null;
      }
      const envelope = Object.freeze({
        schema_version: 1,
        event_name: name,
        event_id: window.crypto.randomUUID(),
        occurred_at: Math.floor(Date.now() / 1000),
        source: 'shopify_insights',
        properties: Object.freeze(safeProperties)
      });
      if (key) {
        window.sessionStorage.setItem(storageKey, JSON.stringify([...stored, key]));
        seen.add(key);
      }
      const packet = Object.freeze({
        envelope,
        ga4: allowed.ga4 ? Object.freeze({name: names[name].ga4,
          parameters: Object.freeze({event_id: envelope.event_id, ...safeProperties})}) : null,
        meta: allowed.meta ? Object.freeze({name: names[name].meta,
          custom: true, event_id: envelope.event_id, properties: envelope.properties}) : null
      });
      void send(packet);
      return packet;
    } catch (_) {
      return null;
    }
  }

  function reportViewed(root, reportType, localDedupeKey) {
    let eligible = permissions();
    if ((!eligible.ga4 && !eligible.meta) || root.dataset.designMode === 'true') return;
    function stop() {
      document.removeEventListener('visibilitychange', visible);
      document.removeEventListener('visitorConsentCollected', visible);
      document.removeEventListener('shopify:section:unload', unloaded);
      window.removeEventListener('pagehide', stop);
    }
    function unloaded(event) { if (event.target.contains(root)) stop(); }
    function visible() {
      const current = permissions();
      eligible = {ga4: eligible.ga4 && current.ga4, meta: eligible.meta && current.meta};
      if (!root.isConnected || (!eligible.ga4 && !eligible.meta)) { stop(); return; }
      if (document.hidden || !root.getClientRects().length || window.getComputedStyle(root).visibility === 'hidden') return;
      stop();
      return track('report_viewed', {report_type: reportType}, localDedupeKey, eligible);
    }
    document.addEventListener('visibilitychange', visible);
    document.addEventListener('visitorConsentCollected', visible);
    document.addEventListener('shopify:section:unload', unloaded);
    window.addEventListener('pagehide', stop);
    return visible();
  }

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-insights-cta]') ||
      event.target.closest?.('a.st-editor-cta, a.focus-content__button, .optimizzer-career a, .optimizzer-about a');
    if (!link || event.defaultPrevented || (event.button != null && event.button !== 0)) return;
    try {
      const url = new URL(link.href, window.location.href);
      if (link.matches?.('.optimizzer-career .oc-pdf') && url.protocol === 'https:' &&
          url.pathname.toLowerCase().endsWith('.pdf')) {
        // A requested PDF, not proof that the visitor saved it on their device.
        window.shoptimizerCustomerEvents?.publish('shoptimizer_tool_downloaded', {format: 'pdf'});
        return;
      }
      const contact = link.closest?.('.optimizzer-career, .optimizzer-about') &&
        ((url.protocol === 'mailto:' && ['info@optimizzer.at', 'office@optimizzer.at', 'info@shoptimizer.at', 'office@shoptimizer.at'].includes(url.pathname)) ||
         (url.protocol === 'tel:' && url.pathname === '+436644686119'));
      if (!contact && !['http:', 'https:'].includes(url.protocol)) return;
      let target = contact ? 'contact' : (link.dataset.insightsCta === 'register' ? '' : link.dataset.insightsCta);
      const destination = pageFor(url);
      if (url.origin === window.location.origin && ['/pages/contact-us', '/pages/tools-trial'].includes(destination)) target = 'contact';
      else if ((url.origin === window.location.origin && destination === '/pages/insights-competitors') ||
          (url.hash === '#insights-suche' && url.origin === window.location.origin &&
           url.pathname === window.location.pathname &&
           document.querySelector('[data-oi-hero][data-analysis-mode="competitors"]'))) target = 'compare';
      else if (managerEntries.some(entry => url.origin === entry.origin &&
          url.pathname.replace(/\/$/, '') === entry.pathname.replace(/\/$/, '') && url.hash === entry.hash)) target = 'register';
      if (!['compare', 'register', 'contact'].includes(target)) return;
      window.shoptimizerInsightsTracking.track('cta_clicked', {target});
    } catch (_) {}
  });

  document.addEventListener('visitorConsentCollected', () => {
    const current = permissions();
    if (!current.ga4 && !current.meta) {
      try { window.sessionStorage.removeItem(storageKey); } catch (_) {}
    }
  });
  window.shoptimizerInsightsTracking = {track, reportViewed};
})();
